import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

import { ViewPageWrapper } from '../pages/ViewPageWrapper'

const PublicRoutes = () => {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path='site(:siteId)/*' element={<PublicSiteRoutes />} />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const PublicLayout = () => {
  return <div className='container my-5'>
    <Outlet />
  </div>
}

const PublicSiteRoutes = () => {
  return (
    <Routes>
      <Route>
        <Route path='page(:pageId)' element={<ViewPageWrapper />} />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes >
  )
}

export { PublicRoutes }

